module.exports = __webpack_public_path__ + "img/home_chart_it.336a953.png";